jQuery( document ).ready(function($) { 
  /* SlimMenu Prep */
  $('#navigation').slimmenu({
    resizeWidth: '1200',
    collapserTitle: '',
    animSpeed: 150,
    easingEffect: 'easeInSine',
    indentChildren: false,
    childrenIndenter: '&nbsp;',
    expandIcon: '',
    collapseIcon: ''
  });

  $('.image-carousel').not('.slick-initialized').slick({
    dots: false,
    arrows: true,
    infinite: true,
    speed: 300,
    slidesToShow: 1,
    centerMode: true,
    variableWidth: true,  
    autoplay: true,
    autoplaySpeed: 3000
  });

  $('.instagram-carousel').not('.slick-initialized').slick({
    dots: false,
    arrows: true,
    infinite: true,
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 3,
    adaptiveHeight: true,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });

  $('a').click(function(event) {
    // On-page links
    if ( (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '')) && (location.hostname == this.hostname) && !$(this).hasClass("no-scroll") ) {
      // Figure out element to scroll to
      var target = $(this.hash);
      target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
      // Does a scroll target exist?
      if (target.length) {
        // Only prevent default if animation is actually gonna happen
        event.preventDefault();
        var $target = $(target);
        //$target.focusWithoutScrolling();
        $('html, body').animate({
          scrollTop: target.offset().top - 150
        }, 700);
      }
    }
  });

  var select = $('.select-styled');
  select.each(function() {
    var box = $(this).find('select');
    var label = $(this).find('label');
    var labeltext = $(this).find('label').text();
    var first = box.children('option').first();
    first.text(labeltext).attr('disabled', true);
    label.hide();
  });

  var teamName = $('.box-name h5');
  teamName.each(function() {
    var newName = $(this).html().replace(' ', '<br/>');
    $(this).html(newName);
  });

  var itemToMove = $("a.move-to-mobile");
  var mobileMenu = $("#navigation");
  if (itemToMove.length != null) {
    itemToMove.each(function() {
      var itemLink = $(this).attr("href");
      mobileMenu.append("<li class=\"d-flex d-xl-none\"><a href=\"" + itemLink + "\">" + $(this).html() + "</a></li>");
      $(this).addClass("d-none d-xl-flex");
    });
  }

});

$('.edn__contentBlock_previousPage, .edn__contentBlock_nextPage').on('click', function() {
  setTimeout(function() {
    var teamName = $('.box-name h5');
    teamName.each(function() {
      var newName = $(this).html().replace(' ', '<br/>');
      $(this).html(newName);
    });
  }, 750);
});

$.fn.focusWithoutScrolling = function() {
  if (this[0].hasAttribute('tabindex')) {
    this.focus();
  } else {
    this.attr('tabindex','1').focus();
  }
  return this;
};
